import React from 'react'
import { useEffect } from 'react'
import { useState } from 'react'
import { createContext } from 'react'
import { useScreenSize } from 'src/customHooks/customHooks'

export const ClinicLayoutContext = createContext(null)

export default function ClinicLayoutProvider({ children }) {
  const [showSidebar, setShowSidebar] = useState(false)
  const { width } = useScreenSize()

  function toggleSidebar() {
    setShowSidebar((prev) => !prev)
  }

  useEffect(() => {
    if (width <= 768) {
      setShowSidebar(false)
    }
  }, [width])

  return (
    <ClinicLayoutContext.Provider value={{ showSidebar, toggleSidebar }}>
      {children}
    </ClinicLayoutContext.Provider>
  )
}
